export const makeCrontime = ({minute, hour, dayOfMonth, month, dayOfWeek}) => `${minute} ${hour} ${dayOfMonth} ${month} ${dayOfWeek}`;

const isEvery = (value) => value === '*';

const parseStep = (value) => {
    const match = /^\*\/(\d+)$/.exec(value);
    return match ? Number(match[1]) : null;
};

const isFixedNumber = (value) => /^\d+$/.test(value);

const formatClock = (hour, minute) => {
    const hourNumber = Number(hour);
    const minuteNumber = Number(minute);
    const period = hourNumber >= 12 ? 'PM' : 'AM';
    const hour12 = hourNumber % 12 || 12;

    return `${hour12}:${String(minuteNumber).padStart(2, '0')} ${period}`;
};

const formatTime = (hour, minute) => {
    if(isFixedNumber(hour) && isFixedNumber(minute)) {
        return formatClock(hour, minute);
    }

    return `${hour}:${minute}`;
};

const formatHourRange = (hour) => `${formatClock(hour, '0')} đến ${formatClock(hour, '59')}`;

const formatHourCycle = (hourStep) => {
    if(hourStep === 2) return 'mỗi 2 giờ, vào giờ chẵn';

    return `các giờ theo chu kì */${hourStep}`;
};

const describeDayOfWeek = (dayOfWeek) => {
    const dayMap = {
        '0': 'Chủ nhật',
        '1': 'thứ 2',
        '2': 'thứ 3',
        '3': 'thứ 4',
        '4': 'thứ 5',
        '5': 'thứ 6',
        '6': 'thứ 7',
        '7': 'Chủ nhật',
    };

    return dayMap[dayOfWeek] || `thứ ${dayOfWeek}`;
};

const describeDateScope = ({dayOfMonth, month, dayOfWeek}) => {
    const dayOfMonthStep = parseStep(dayOfMonth);
    const monthStep = parseStep(month);
    const dayOfWeekStep = parseStep(dayOfWeek);

    if(isEvery(dayOfMonth) && isEvery(month) && isEvery(dayOfWeek)) return '';

    if(isEvery(dayOfMonth) && isEvery(month) && !isEvery(dayOfWeek)) {
        if(dayOfWeekStep) return `, mỗi ${dayOfWeekStep} ngày trong tuần một lần`;

        return `, vào ${describeDayOfWeek(dayOfWeek)} hằng tuần`;
    }

    if(!isEvery(dayOfMonth) && isEvery(month) && isEvery(dayOfWeek)) {
        if(dayOfMonthStep) return `, mỗi ${dayOfMonthStep} ngày một lần`;

        return `, vào ngày ${dayOfMonth} hằng tháng`;
    }

    if(isEvery(dayOfMonth) && !isEvery(month) && isEvery(dayOfWeek)) {
        if(monthStep) return `, mỗi ${monthStep} tháng một lần`;

        return `, vào tháng ${month} hằng năm`;
    }

    if(!isEvery(dayOfMonth) && !isEvery(month) && isEvery(dayOfWeek)) {
        if(monthStep) return `, mỗi ${monthStep} tháng một lần vào ngày ${dayOfMonth}`;

        return `, vào ngày ${dayOfMonth} tháng ${month} hằng năm`;
    }

    if(!isEvery(dayOfMonth) && isEvery(month) && !isEvery(dayOfWeek)) {
        return `, vào ngày ${dayOfMonth} hằng tháng, thứ ${describeDayOfWeek(dayOfWeek)}`;
    }

    if(isEvery(dayOfMonth) && !isEvery(month) && !isEvery(dayOfWeek)) {
        return `, vào ${describeDayOfWeek(dayOfWeek)}, tháng ${month} hằng năm`;
    }

    if(!isEvery(dayOfMonth) && !isEvery(month) && !isEvery(dayOfWeek)) {
        return `, vào ngày ${dayOfMonth} tháng ${month}, ${describeDayOfWeek(dayOfWeek)}`;
    }

    return `, theo ngày ${dayOfMonth}, tháng ${month}, thứ ${dayOfWeek}`;
};

export const describeCron = ({minute = '*', hour = '*', dayOfMonth = '*', month = '*', dayOfWeek = '*'}) => {
    const crontime = makeCrontime({minute, hour, dayOfMonth, month, dayOfWeek});
    const minuteStep = parseStep(minute);
    const hourStep = parseStep(hour);
    const dateScope = describeDateScope({dayOfMonth, month, dayOfWeek});

    if(isEvery(minute) && isEvery(hour)) {
        return `Chạy mỗi phút${dateScope}`;
    }

    if(minuteStep && isEvery(hour)) {
        return `Chạy mỗi ${minuteStep} phút một lần${dateScope}`;
    }

    if(isFixedNumber(hour)) {
        if(isEvery(minute)) {
            return `Chạy mỗi phút, từ ${formatHourRange(hour)}${dateScope}`;
        }

        if(minuteStep) {
            return `Chạy mỗi ${minuteStep} phút một lần, từ ${formatHourRange(hour)}${dateScope}`;
        }

        if(isFixedNumber(minute)) {
            if(dateScope) return `Chạy lúc ${formatTime(hour, minute)}${dateScope}`;

            return `Chạy mỗi ngày lúc ${formatTime(hour, minute)}`;
        }
    }

    if(hourStep) {
        if(isFixedNumber(minute)) {
            return `Chạy mỗi ${hourStep} giờ một lần, vào phút ${minute} của ${formatHourCycle(hourStep)}${dateScope}`;
        }

        if(isEvery(minute)) {
            return `Chạy mỗi phút trong ${formatHourCycle(hourStep)}${dateScope}`;
        }

        if(minuteStep) {
            return `Chạy mỗi ${minuteStep} phút trong ${formatHourCycle(hourStep)}${dateScope}`;
        }
    }

    if(isFixedNumber(minute) && isEvery(hour)) {
        return `Chạy mỗi giờ, vào phút ${minute}${dateScope}`;
    }

    return `Chạy theo cron: ${crontime}`;
};
